import { render } from "./HorariosSection.vue?vue&type=template&id=55e918fc&scoped=true"
import script from "./HorariosSection.vue?vue&type=script&lang=js"
export * from "./HorariosSection.vue?vue&type=script&lang=js"

import "./HorariosSection.vue?vue&type=style&index=0&id=55e918fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e918fc"]])

export default __exports__